'use strict';

import React from 'react'

import AutoCompletedField from '@Pure/AutoCompletedField'

import FormElement from '@/Form/toolkit/FormElement'
import FileInput   from '@/Form/toolkit/FileInput'

export default function getFormElement (name, key, wrapped, iterator, parent_name, disabled=false)
{
	const component = this, props = this.props, config = this.props.config || component.config;

	const field_config = config.fields[name], state = this.state;

	if (typeof iterator === 'number' && field_config.label)
	{
		field_config.label = undefined;
	}

	var options, output, recomposed_name = config.model;

	if (typeof field_config.model !== 'undefined')
	{
		recomposed_name = field_config.model || '';
	}

	name.split('[').join(']').split(']')
	.filter(function (str)
	{
		return str !== '' ? true : false;
	})
	.forEach(function (prop)
	{
		if (recomposed_name !== '')
		{
			recomposed_name += '[' + prop + ']';
		}
		else
		{
			recomposed_name += prop;
		}

		if (prop === parent_name && typeof iterator === 'number')
		{
			recomposed_name += '[' + iterator + ']';
		}
	});

	if (field_config.options)
	{
		options = [];

		field_config.options.forEach(function (option, key)
		{
			options.push(
				<option value={ option.value } key={ key }>
					{ option.label || option.value }
				</option>
			);
		});
	}

	var class_name = undefined, autocomplete_data = [], model;

	if (field_config.show instanceof Function)
	{
		class_name = 'c-form-element c-form-element--conditionnal';
	}

	let field_name = recomposed_name, search = field_config.search || { };

	let readOnly = disabled === true;

	if ([true, false, 'true', 'false'].includes(field_config.readOnly))
	{
		readOnly = field_config.readOnly;
	}

	if ([true, 'true'].includes(component.state.readOnly))
	{
		readOnly = component.state.readOnly;
	}

	if (field_config.reference)
	{
		model = field_config.reference.model;

		if (app.state.autocomplete_data[model])
		{
			autocomplete_data = app.state.autocomplete_data[model].slice();
		}

		let autocomplete_value;

	// display name exists and there is no id for the field.
		if (typeof state.form_data['__display__' + field_name] !== 'undefined' &&
			!state.form_data[field_name])
		{
			autocomplete_value = state.form_data['__display__'+ field_name];
		}
		else
		{
			autocomplete_value = state.form_data[field_name];
		}

		let proposition = autocomplete_data.find(data => data.id === autocomplete_value);

		if (proposition)
		{
			if (typeof proposition.value === 'string')
			{
				autocomplete_value = proposition.value;
			}
			else if (proposition.value instanceof Object)
			{
				autocomplete_value = Object.keys(proposition.value)
				.reduce(function (final_value, prop)
				{
					if (search.display_fields instanceof Array === false)
					{
						if (final_value) final_value += ' ';

						final_value += proposition.value[prop];
					}
					else if (search.display_fields.indexOf(prop) !== -1)
					{
						if (final_value) final_value += ' ';

						final_value += proposition.value[prop];
					}

					return final_value;
				}, '');
			}
		}

		output =
		(
			<AutoCompletedField data={ autocomplete_data }
				name={ field_name } id_prefix="creation-form-"
				onChange={ component.handleChange } label={ field_config.label }
				value={ autocomplete_value }
				status={ component.state.status_messages }
				referenced_value={ true }
				display_fields={ search.display_fields }
				front_indicator={ Boolean(field_config.front_indicator) }
				readOnly={ readOnly || false } />
		);
	}
	else if (['image', 'pdf'].includes(field_config.type))
	{
		output =
		(
			<FileInput className={ class_name }
				id_prefix="simple-product-form-" label={ field_config.label }
				name={ name } reset={ state.form_data[name] ? false : true }
				onChange={ component.handleChange } data={ state.form_data }
				multiple={ field_config.multiple ? 'multiple' : false }
				status={ state.status_messages }
				accept={ field_config.type === 'image' ? '.svg,.jpg,.jpeg,.png' : '.pdf' }
				front_indicator={ Boolean(field_config.front_indicator) }
				readOnly={ readOnly || false }>
			</FileInput>
		);
	}
	else if (field_config.type === 'select')
	{
		let has_empty_option = field_config.options.find(option => option.value === '');

		has_empty_option = typeof has_empty_option !== 'undefined';

		output =
		(
			<FormElement className={ class_name } defaultValue={ field_config.defaultValue }
				type="select" name={ field_name } data={ state.form_data }
				onChange={ component.handleChange } autoComplete={ 'new-' + name }
				status={ state.status_messages } label={ field_config.label }
				front_indicator={ Boolean(field_config.front_indicator) }
				readOnly={ readOnly || false } has_empty_option={ has_empty_option }>
				{ options }
			</FormElement>
		);
	}
	else
	{
		let valueHook;

		if (field_config.valueHook instanceof Function)
		{
			valueHook = field_config.valueHook;
		}

		output =
		(
			<FormElement className={ class_name } name={ field_name }
				type={ field_config.type || 'text' } data={ state.form_data }
				onChange={ component.handleChange } autoComplete={ 'new-' + name }
				status={ state.status_messages } label={ field_config.label }
				front_indicator={ Boolean(field_config.front_indicator) }
				readOnly={ readOnly || false } valueHook={ valueHook }
				min={ field_config.min } max={ field_config.max }
				images={ field_config.images } color={ field_config.color }
				column={ field_config.column }
			/>
		);
	}

	if (wrapped === false)
	{
		return <span key={ key }>{ output }</span>;
	}
	else
	{
		let class_name = 'o-grid__item';
		
		if (field_config['col-size']) class_name += '-' + field_config['col-size'];

		return (<div key={ key } className={ class_name }>{ output }</div>);
	}
}